import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";

const Deals = (props) => {
    const [dealTableData, setDealTableData] = useState([]);

    useEffect(() => {
        let data = props.data;

        // Check for empty data and skip processing
        if (data.length === 0) return;

        // Check for undefined values and replace
        data = data.map((item) => {
            Object.keys(item).forEach((key) => {
                if (item[key] === undefined || item[key] === null) {
                    item[key] = "-";
                }

                if (key === "properties") {
                    Object.keys(item[key]).forEach((nestedKey) => {
                        if (item[key][nestedKey] === undefined || item[key][nestedKey] === null) {
                            item[key][nestedKey] = "-";
                        }

                        if (nestedKey === "dealname") {
                            item[nestedKey] = (
                                <a
                                    rel="noreferrer"
                                    href={item["ng_deal_url"] ? item["ng_deal_url"] : "#"}
                                    target="_blank"
                                >
                                    {item[key][nestedKey] ? item[key][nestedKey] : "-"}
                                </a>
                            );
                        }

                        if (nestedKey === "closedate") {
                            const date = new Date(item[key][nestedKey]);
                            if (date) {
                                const formattedDate = `${
                                    date.getMonth() + 1
                                }/${date.getDate()}/${date.getFullYear()}`;
                                item[nestedKey] = formattedDate;
                            } else item[nestedKey] = "-";
                        }

                        if (nestedKey === "amount") {
                            // take the string and convert it to a number - limiting to 2 decimal places converts it back to string...
                            if (item[key][nestedKey]) {
                                let amount = parseFloat(item[key][nestedKey]).toFixed(2);

                                // reconvert back to number for toLocaleString to work...
                                amount = parseFloat(amount).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                });
                                item["amount_modified"] = "$" + amount;
                            } else item[nestedKey] = "-";
                        }
                    });
                }
            });
            return item;
        });

        // Sort data by close date desc
        data.sort((a, b) => new Date(b.properties.closedate) - new Date(a.properties.closedate));

        setDealTableData(data);
    }, [props.data]);

    const columns = [
        {
            name: "dealname",
            label: "Deal Name",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "amount_modified",
            label: "Amount",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "closedate",
            label: "Close Date",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "hubspot_owner_id__name",
            label: "Deal Owner",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "dealstage__name",
            label: "Deal Stage",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "pipeline__name",
            label: "Pipeline",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        searchAlwaysOpen: true,
        storageKey: "dealsTable",
        filter: false,
        sort: false,
        viewColumns: false,
        print: false,
        download: false,
        search: false,
        columnOrder: null,
        fixedHeader: true,
        pagination: false,
        // rowsPerPage: 5,
        // rowsPerPageOptions: [5, 10, 25, 50, 100],
    };

    return (
        <div className="mt-12 flex w-full flex-col">
            <h4 className="pb-2">Deals</h4>

            <MUIDataTable
                data={dealTableData}
                columns={columns}
                options={options}
                style={{ marginTop: "50px" }}
                className="ngShadow"
            />
        </div>
    );
};

export default Deals;
